import currencyList from "../constants/currencies.json"

interface CurrencyOptions {
  label: string
  value: string
}

export const getCurrencyList = ({excludeInternalCurrencies} = {excludeInternalCurrencies: false}): CurrencyOptions[] => {
  if (excludeInternalCurrencies) {
    return currencyList
  }

  const flexiCurrencies = [
    {label: "Flexi Points", value: "TT"},
    {label: "Reward Points", value: "RP"},
    {label: "Merchandise Points", value: "MP"}
  ]
  return flexiCurrencies.concat(currencyList)
}

/**
 * Get the cost of tax applied to a given fee
 * all values returned in cents
 *
 * rounding calculated as per https://www.gov.uk/hmrc-internal-manuals/vat-trader-records/vatrec12030
 */
export const getTaxCost = ({
  totalBeforeTax,
  tax,
  isCents = true
}: {
  totalBeforeTax: number
  isCents?: boolean
  tax?: number
}): {
  appliedTaxPercentage: number
  taxCost: number
  totalBeforeTax: number
  totalCost: number
} => {
  const appliedTaxPercentage = tax ?? 0
  const totalBeforeTaxAsCents = isCents ? totalBeforeTax : totalBeforeTax * 100
  const taxCost = Math.round((totalBeforeTaxAsCents * appliedTaxPercentage) / 100)

  return {
    appliedTaxPercentage,
    taxCost,
    totalBeforeTax: totalBeforeTaxAsCents,
    totalCost: totalBeforeTaxAsCents + taxCost
  }
}
